export default {
  hello_world : 'Hola mundo',
  /*TournamentRegistrationForm*/
  tournament_registration_form_msg_1 : "Por favor, completa tus datos a continuación.",
  tournament_registration_form_team_data : "Datos del Equipo",
  tournament_registration_form_team_name : "Nombre del Equipo",
  tournament_registration_form_league_name : "Nombre de la Liga Local",
  tournament_registration_form_team_city : "Ciudad del Equipo",
  tournament_registration_form_coach_data  : "Datos del Entrenador",
  tournament_registration_form_coach_name : "Nombre",
  tournament_registration_form_coach_last_name : "Apellido",
  tournament_registration_form_coach_phone : "Celular",
  tournament_registration_form_coach_email : "Email",
  tournament_registration_form_coach_email_confirm : "Confirmar Email",
  tournament_registration_form_coach_country : "Pais",
  tournament_registration_form_coach_state : "Estado",
  tournament_registration_form_coach_postal_code : "Codigo Postal",
  tournament_registration_form_coach_social_data : "Social",
  tournament_registration_form_how_do_you_find : "¿Cómo se ha enterado de Alianza?",
  tournament_registration_form_how_do_you_find_1 : "Facebook",
  tournament_registration_form_how_do_you_find_2 : "Twitter",
  tournament_registration_form_how_do_you_find_3 : "Instagram",
  tournament_registration_form_how_do_you_find_4 : "Website",
  tournament_registration_form_how_do_you_find_5 : "Familiar",
  tournament_registration_form_how_do_you_find_6 : "Entrenador",
  tournament_registration_form_how_do_you_find_7 : "Amigo",
  tournament_registration_form_how_do_you_find_8 : "TV",
  tournament_registration_form_how_do_you_find_9 : "Periodico",
  tournament_registration_form_how_do_you_find_10 : "Radio",
  tournament_registration_form_how_do_you_find_11 : "Presidente de Liga",
  tournament_registration_form_how_do_you_find_12 : "Otro",
  tournament_registration_form_send_btn : "Registrar equipo",
  tournament_registration_form_thanks : "Gracias, tu solicitud se ha enviado con éxito. Por favor revisa tu correo electrónico para más detalles.",
  tournament_registration_form_confirmation_email_error : "El email y su confirmación no coinciden.",
  /*Alerts*/
  alerts_error_title : "Ha ocurrido un error",
  alerts_accept : "Aceptar"
}



// WEBPACK FOOTER //
// ./src/lang/es.js